module.exports = __webpack_public_path__ + "img/mizhi-back-cp@3x.fe3e3831.png";